import React, { useRef, useState } from "react";
import FileSaver from 'file-saver';
import Editor from "@monaco-editor/react";
import AppJson from './App.json';
import userConfig from './userConfig.json';

function IdeApp() {

  const detectDeviceType = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  ? 'Mobile'
  : 'Desktop';

  const editorRef = useRef(null);

  var [cont, edContent] = useState("");

  //editor functions
  const handleSave = () => {
    console.log("saving file => newFile."+AppJson.extension)
    const fileSave = editorRef.current.getValue();
    var file = new File([fileSave], "newFile."+AppJson.extension);
      FileSaver.saveAs(file);
  }

  const handleLoad = () => {
    if(userConfig.showWarnings === true){
      var confirmOption = window.confirm('[WARNING] Import files?\nRemember to save your current files!');
      if(confirmOption){
        load();
      }
    }else{
      load();
    }
  }

  function handleEditorDidMount(editor, monaco) {
    // here is the editor instance
    // you can store it in `useRef` for further usage
    editorRef.current = editor; 
  }

  function load() {
    var input = document.createElement('input');
    input.type = 'file';
    input.onchange = e => {
      // getting a hold of the file reference
      var file = e.target.files[0]; 
      // setting up the reader
      var reader = new FileReader();
      reader.readAsText(file,'UTF-8');
      // here we tell the reader what to do when it's done reading...
      reader.onload = readerEvent => {
        var content = readerEvent.target.result; // this is the content!
        edContent = content;
      }
    }
    input.click();
  }  

  

  return (
    <div style={{backgroundColor: '#1F1F1E', height: '100vh'}}>
      <div style={{display: 'flex', marginBottom: '20px', backgroundColor: '#111'}}>
        <img onClick={goBack} alt="exIDE banner" style={{maxWidth: '150px', outlineWidth: '5px', outlineColor: '#1F1F1E', outlineStyle: 'solid', marginRight: detectDeviceType() === 'Desktop' ? '14px' : '8px'}} src={require('./exIDE_banner.jpg')} />
        <div style={{padding: '20px'}}>
          <button 
          style={{backgroundColor: '#111', fontSize: '18px', color: "white", border: 'none', height: '40px', marginRight: detectDeviceType() === 'Desktop' ? '20px' : '8px'}}
          onClick={handleSave}
          >SAVE</button>
          <button 
          style={{backgroundColor: '#111', fontSize: '18px', color: "white", border: 'none', height: '40px'}}
          onClick={handleLoad}
          >LOAD</button>
        </div>
      </div>
      <Editor
        id="ideAppEditor"
        height="85vh"
        value={cont}
        theme={"vs-dark"}
        language={AppJson.lang}
        onChange={(value) => edContent(value)}
        onMount={handleEditorDidMount}
      />
    </div>
  );
  
  function goBack(){
    const ide = document.getElementById("ide");
    /* const page = document.getElementById("entirePage"); */
    const mainMenu = document.getElementById("mainMenu");
    if(userConfig.showWarnings === true){
      var confirmOption = window.confirm('[WARNING] Go back?\nRemember to save your current files!')
      if(confirmOption){
        edContent('');
        ide.style.display = "none";
        mainMenu.style.display = "block";
      }
    }else{
      edContent('');
      ide.style.display = "none";
      mainMenu.style.display = "block";
    }
  }

}

export default IdeApp;